// import React, { useEffect, useMemo, useState, useCallback } from "react";
// import { Search, TrendingUp, Download, Package, DollarSign, UserCheck, MapPin } from "lucide-react";
// import { clientsList, ordersList, scoring } from "../../../../../api/auth";
// import { useToast } from "../../components/clients/Toast";

// /* ===============================
//    DASHBOARD HELPERS
// ================================ */
// const formatCurrency = (val) => new Intl.NumberFormat('fr-MA', { style: 'currency', currency: 'MAD' }).format(val);

// // Logic dyal l-alwan 3la hsab l-points li 3titini
// const getTrustStyles = (score) => {
//   const s = Number(score);
//   if (s >= 0 && s <= 24) return { label: "BLACKLIST", bg: "bg-slate-900 text-white border-slate-800", dot: "bg-white" };
//   if (s >= 25 && s <= 49) return { label: "RED", bg: "bg-rose-50 text-rose-700 border-rose-100", dot: "bg-rose-500" };
//   if (s >= 50 && s <= 74) return { label: "BLUE", bg: "bg-blue-50 text-blue-700 border-blue-100", dot: "bg-blue-500" };
//   if (s >= 75 && s <= 100) return { label: "GREEN", bg: "bg-emerald-50 text-emerald-700 border-emerald-100", dot: "bg-emerald-500" };
//   return { label: "PENDING", bg: "bg-slate-50 text-slate-400 border-slate-100", dot: "bg-slate-300" };
// };

// const extractCity = (client) => {
//   if (client.city) return client.city;
//   const addr = (client.address || "").toLowerCase();
//   if (addr.includes("مراكش") || addr.includes("marrakech")) return "Marrakech";
//   if (addr.includes("casablanca") || addr.includes("الدار البيضاء")) return "Casablanca";
//   if (addr.includes("safi") || addr.includes("آسفي")) return "Safi";
//   return "Inconnu";
// };

// /* ===============================
//    MAIN COMPONENT
// ================================ */
// export default function ClientsList() {
//   const toast = useToast();
//   const [clients, setClients] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [activeFilter, setActiveFilter] = useState("all");
//   const [selectedClient, setSelectedClient] = useState(null);

//   const loadData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const [cRes, oRes] = await Promise.all([clientsList(), ordersList()]);
//       const rawClients = cRes.data?.results || cRes.data || [];
//       const rawOrders = oRes.data?.results || oRes.data || [];

//       const ordersMap = new Map();
//       rawOrders.forEach(o => {
//         const phone = o.phone || o.client_phone;
//         if (!phone) return;
//         const list = ordersMap.get(phone) || [];
//         list.push(o);
//         ordersMap.set(phone, list);
//       });

//       const processed = rawClients.map(c => {
//         const cOrders = ordersMap.get(c.phone) || [];
//         return {
//           ...c,
//           cityDisplay: extractCity(c),
//           totalOrders: cOrders.length,
//           totalRevenue: cOrders.reduce((sum, o) => sum + Number(o.total_amount || 0), 0),
//           trust: { score: null, category: "PENDING", styles: getTrustStyles(-1), reasons: [] }
//         };
//       });

//       setClients(processed);
//       fetchScores(processed);
//     } catch (err) {
//       toast.push({ title: "Error", message: "Impossible de charger les données." });
//     } finally {
//       setLoading(false);
//     }
//   }, [toast]);

//   const fetchScores = async (list) => {
//     for (const c of list) {
//       if (!c.phone) continue;
//       try {
//         const res = await scoring(c.phone);
//         const final = res.data?.final;
//         if (final) {
//           const scoreVal = Math.round(final.score_100);
//           setClients(prev => prev.map(item => item.id === c.id ? {
//             ...item,
//             trust: {
//               score: scoreVal,
//               category: final.category?.value,
//               reasons: final.category?.reasons || [],
//               styles: getTrustStyles(scoreVal)
//             },
//             fullScoring: res.data
//           } : item));
//         }
//       } catch (e) { console.warn("Scoring skip", c.phone); }
//     }
//   };

//   useEffect(() => { loadData(); }, [loadData]);

//   const filteredClients = useMemo(() => {
//     return clients.filter(c => {
//       const matchesSearch = c.full_name?.toLowerCase().includes(searchTerm.toLowerCase()) || c.phone?.includes(searchTerm);
//       const matchesCategory = activeFilter === "all" || c.trust.styles.label === activeFilter;
//       return matchesSearch && matchesCategory;
//     });
//   }, [clients, searchTerm, activeFilter]);

//   if (loading) return <div className="p-20 text-center font-bold text-slate-400">Chargement de la base de données...</div>;

//   return (
//     <div className="min-h-screen bg-[#F9FAFB] p-6 lg:p-10">
//       <div className="max-w-7xl mx-auto space-y-8">
        
//         {/* Header */}
//         <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
//           <div>
//             <h1 className="text-3xl font-black text-slate-900 tracking-tight">E-COMMERCE CRM</h1>
//             <p className="text-slate-500 font-medium italic">Base de données clients & scoring de confiance</p>
//           </div>
//           <button className="flex items-center gap-2 bg-slate-900 text-white px-6 py-3 rounded-2xl font-bold hover:scale-105 transition-all shadow-xl">
//             <Download size={18} />
//             <span>Exporter CSV</span>
//           </button>
//         </div>

//         {/* Stats Grid */}
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//           <StatCard title="Volume Clients" value={clients.length} icon={<Package size={24} />} color="indigo" />
//           <StatCard title="Total Revenue" value={formatCurrency(clients.reduce((s,c) => s + c.totalRevenue, 0))} icon={<DollarSign size={24} />} color="emerald" />
//           <StatCard title="Top Green" value={clients.filter(c => c.trust.score >= 75).length} icon={<UserCheck size={24} />} color="blue" />
//         </div>

//         {/* Search & Filter Bar */}
//         <div className="bg-white p-5 rounded-[2rem] border border-slate-100 shadow-xl shadow-slate-200/40 flex flex-col md:flex-row gap-6 items-center">
//           <div className="relative w-full md:w-1/2">
//             <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-300" size={20} />
//             <input 
//               type="text" 
//               placeholder="Nom, téléphone..." 
//               className="w-full pl-12 pr-4 py-3.5 bg-slate-50 border-none rounded-2xl focus:ring-2 focus:ring-slate-900 transition-all font-medium"
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//           </div>
//           <div className="flex items-center gap-2 overflow-x-auto w-full md:w-auto">
//             {['all', 'GREEN', 'BLUE', 'RED', 'BLACKLIST'].map(cat => (
//               <button 
//                 key={cat}
//                 onClick={() => setActiveFilter(cat)}
//                 className={`px-5 py-2.5 rounded-xl text-xs font-black tracking-widest transition-all uppercase border-2 ${activeFilter === cat ? 'bg-slate-900 text-white border-slate-900 shadow-lg' : 'bg-white text-slate-400 border-slate-100 hover:border-slate-200'}`}
//               >
//                 {cat}
//               </button>
//             ))}
//           </div>
//         </div>

//         {/* Professional Table */}
//         <div className="bg-white rounded-[2.5rem] border border-slate-100 shadow-2xl overflow-hidden">
//           <table className="w-full text-left">
//             <thead>
//               <tr className="bg-slate-50/80 border-b border-slate-100">
//                 <th className="px-8 py-5 text-[10px] font-black text-slate-400 uppercase tracking-[0.2em]">Profil Client</th>
//                 <th className="px-8 py-5 text-[10px] font-black text-slate-400 uppercase tracking-[0.2em]">Ville</th>
//                 <th className="px-8 py-5 text-[10px] font-black text-slate-400 uppercase tracking-[0.2em]">Stats</th>
//                 <th className="px-8 py-5 text-[10px] font-black text-slate-400 uppercase tracking-[0.2em]">Trust Scoring</th>
//                 <th className="px-8 py-5 text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] text-right">Analyse</th>
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-slate-50">
//               {filteredClients.map(c => (
//                 <tr key={c.id} className="hover:bg-slate-50/30 transition-all group">
//                   <td className="px-8 py-6">
//                     <div className="font-black text-slate-800 text-lg group-hover:text-indigo-600 transition-colors uppercase">{c.full_name}</div>
//                     <div className="text-xs text-slate-400 font-bold tracking-widest">{c.phone}</div>
//                   </td>
//                   <td className="px-8 py-6">
//                     <div className="flex items-center gap-2 text-slate-500 font-bold text-sm">
//                       <MapPin size={16} className="text-slate-300" />
//                       {c.cityDisplay}
//                     </div>
//                   </td>
//                   <td className="px-8 py-6">
//                     <div className="flex flex-col">
//                       <span className="text-xs font-black text-slate-900">{c.totalOrders} CMD</span>
//                       <span className="text-xs font-bold text-emerald-500">{formatCurrency(c.totalRevenue)}</span>
//                     </div>
//                   </td>
//                   <td className="px-8 py-6">
//                     <div className={`inline-flex items-center gap-3 px-4 py-2 rounded-2xl border-2 text-xs font-black tracking-tighter uppercase shadow-sm ${c.trust.styles.bg}`}>
//                       <div className={`w-2.5 h-2.5 rounded-full animate-pulse ${c.trust.styles.dot}`} />
//                       {c.trust.styles.label} ({c.trust.score ?? '--'}%)
//                     </div>
//                   </td>
//                   <td className="px-8 py-6 text-right">
//                     <button 
//                       onClick={() => setSelectedClient(c)}
//                       className="text-[10px] font-black text-slate-900 uppercase border-2 border-slate-900 px-5 py-2.5 rounded-xl hover:bg-slate-900 hover:text-white transition-all tracking-widest shadow-md"
//                     >
//                       Détails
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* Modal Detail */}
//       {selectedClient && <ClientDetailModal client={selectedClient} onClose={() => setSelectedClient(null)} />}
//     </div>
//   );
// }

// /* ===============================
//    SUB-COMPONENTS
// ================================ */
// function StatCard({ title, value, icon, color }) {
//   const colors = {
//     indigo: "bg-indigo-50 text-indigo-600 shadow-indigo-100",
//     emerald: "bg-emerald-50 text-emerald-600 shadow-emerald-100",
//     blue: "bg-blue-50 text-blue-600 shadow-blue-100"
//   };
//   return (
//     <div className="bg-white p-8 rounded-[2rem] border border-slate-50 shadow-xl shadow-slate-200/30 flex items-center gap-6 group hover:-translate-y-1 transition-all">
//       <div className={`w-16 h-16 rounded-3xl ${colors[color]} flex items-center justify-center transition-transform group-hover:scale-110`}>
//         {icon}
//       </div>
//       <div>
//         <div className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1">{title}</div>
//         <div className="text-2xl font-black text-slate-900 tracking-tighter">{value}</div>
//       </div>
//     </div>
//   );
// }

// function ClientDetailModal({ client, onClose }) {
//   const scoring = client.fullScoring;
//   return (
//     <div className="fixed inset-0 z-[70] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-md">
//       <div className="bg-white w-full max-w-2xl rounded-[3rem] shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200">
//         <div className="p-10 space-y-10">
//           <div className="flex justify-between items-start">
//              <div>
//                 <h2 className="text-3xl font-black text-slate-900 uppercase tracking-tighter leading-none mb-2">{client.full_name}</h2>
//                 <p className="text-slate-400 font-bold tracking-widest">{client.phone} • {client.cityDisplay}</p>
//              </div>
//              <button onClick={onClose} className="w-12 h-12 bg-slate-100 rounded-full flex items-center justify-center font-bold hover:bg-slate-200 transition-colors">✕</button>
//           </div>

//           <div className="grid grid-cols-2 gap-8">
//              <div className={`p-8 rounded-[2rem] border-4 flex flex-col items-center justify-center gap-2 ${client.trust.styles.bg}`}>
//                 <span className="text-[10px] font-black tracking-widest uppercase">Score de confiance</span>
//                 <span className="text-6xl font-black">{client.trust.score}%</span>
//              </div>
//              <div className="space-y-4">
//                 <div className="p-6 bg-slate-50 rounded-2xl border border-slate-100">
//                    <div className="text-[10px] font-black text-slate-400 uppercase mb-2">Total Commandes</div>
//                    <div className="text-2xl font-black text-slate-900">{client.totalOrders}</div>
//                 </div>
//                 <div className="p-6 bg-slate-50 rounded-2xl border border-slate-100">
//                    <div className="text-[10px] font-black text-slate-400 uppercase mb-2">Total Chiffre d'Affaire</div>
//                    <div className="text-2xl font-black text-emerald-600">{formatCurrency(client.totalRevenue)}</div>
//                 </div>
//              </div>
//           </div>

//           <div className="space-y-4">
//              <h4 className="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em]">Diagnostic Technique</h4>
//              <div className="flex flex-wrap gap-3">
//                 {client.trust.reasons.length > 0 ? client.trust.reasons.map((r, i) => (
//                   <span key={i} className="px-5 py-2.5 bg-slate-900 text-white rounded-xl text-[10px] font-black uppercase tracking-widest">
//                     {r.replace(/_/g, ' ')}
//                   </span>
//                 )) : <span className="text-slate-400 italic text-sm">Aucun motif particulier détecté</span>}
//              </div>
//           </div>
//         </div>
//         <div className="bg-slate-50 p-6 text-center">
//            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">Client enregistré le {new Date(client.created_at).toLocaleDateString()}</p>
//         </div>
//       </div>
//     </div>
//   );
// }
import React, { useEffect, useMemo, useState, useCallback } from "react";
import { Search, Download, Package, DollarSign, UserCheck, ChevronLeft, ChevronRight } from "lucide-react";
import { clientsList, ordersList, scoring } from "../../../../../api/auth";
import { useToast } from "../../components/clients/Toast";

const formatCurrency = (val) => new Intl.NumberFormat('fr-MA', { style: 'currency', currency: 'MAD' }).format(val);

const getTrustStyles = (score) => {
  const s = Number(score);
  if (s >= 0 && s <= 24) return { label: "BLACKLIST", bg: "bg-slate-900 text-white dark:bg-slate-800", dot: "bg-white" };
  if (s >= 25 && s <= 49) return { label: "RED", bg: "bg-rose-100 dark:bg-rose-500/10 text-rose-700 dark:text-rose-400", dot: "bg-rose-500" };
  if (s >= 50 && s <= 74) return { label: "BLUE", bg: "bg-blue-100 dark:bg-blue-500/10 text-blue-700 dark:text-blue-400", dot: "bg-blue-500" };
  if (s >= 75 && s <= 100) return { label: "GREEN", bg: "bg-emerald-100 dark:bg-emerald-500/10 text-emerald-700 dark:text-emerald-400", dot: "bg-emerald-500" };
  return { label: "PENDING", bg: "bg-slate-100 dark:bg-slate-800 text-slate-400 dark:text-slate-500", dot: "bg-slate-300" };
};

export default function ClientsList() {
  const toast = useToast();
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Pagination & Filters State
  const [searchTerm, setSearchTerm] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeFilter, setActiveFilter] = useState("all");
  const [selectedClient, setSelectedClient] = useState(null);

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const [cRes, oRes] = await Promise.all([clientsList(), ordersList()]);
      const rawClients = cRes.data?.results || cRes.data || [];
      const rawOrders = oRes.data?.results || oRes.data || [];

      const ordersMap = new Map();
      rawOrders.forEach(o => {
        const phone = o.phone || o.client_phone;
        if (!phone) return;
        const list = ordersMap.get(phone) || [];
        list.push(o);
        ordersMap.set(phone, list);
      });

      const processed = rawClients.map(c => {
        const cOrders = ordersMap.get(c.phone) || [];
        return {
          ...c,
          totalOrders: cOrders.length,
          totalRevenue: cOrders.reduce((sum, o) => sum + Number(o.total_amount || 0), 0),
          trust: { score: null, styles: getTrustStyles(-1), reasons: [] }
        };
      });

      setClients(processed);
      fetchScores(processed);
    } catch (err) {
      toast.push({ title: "Error", message: "Erreur de chargement." });
    } finally {
      setLoading(false);
    }
  }, [toast]);

  const fetchScores = async (list) => {
    for (const c of list) {
      if (!c.phone) continue;
      try {
        const res = await scoring(c.phone);
        const final = res.data?.final;
        if (final) {
          const s = Math.round(final.score_100);
          setClients(prev => prev.map(item => item.id === c.id ? {
            ...item,
            trust: { score: s, styles: getTrustStyles(s), reasons: final.category?.reasons || [] },
            fullScoring: res.data
          } : item));
        }
      } catch (e) { console.warn("Score skip", c.phone); }
    }
  };

  useEffect(() => { loadData(); }, [loadData]);

  // Filtering & Pagination Logic
  const filtered = useMemo(() => {
    return clients.filter(c => {
      const matchSearch = c.full_name?.toLowerCase().includes(searchTerm.toLowerCase()) || c.phone?.includes(searchTerm);
      const matchCat = activeFilter === "all" || c.trust.styles.label === activeFilter;
      return matchSearch && matchCat;
    });
  }, [clients, searchTerm, activeFilter]);

  const totalPages = Math.ceil(filtered.length / pageSize);
  const paginatedData = filtered.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  useEffect(() => { setCurrentPage(1); }, [searchTerm, pageSize, activeFilter]);

  if (loading) return <div className="p-20 text-center font-bold text-slate-400 dark:text-slate-500">Chargement...</div>;

  return (
    <div className="min-h-screen bg-[#F8FAFC] dark:bg-slate-950 p-4 md:p-10">
      <div className="max-w-7xl mx-auto space-y-6">

        {/* Header Responsive */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <h1 className="text-2xl md:text-3xl font-black text-slate-900 dark:text-slate-100 uppercase">Clients</h1>
          <button className="w-full sm:w-auto flex items-center justify-center gap-2 bg-indigo-600 text-white px-6 py-3 rounded-2xl font-bold shadow-lg shadow-indigo-200">
            <Download size={18} /> <span>Export CSV</span>
          </button>
        </div>

        {/* Stats Cards (Hidden on very small screens or scrollable) */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <StatCard title="Total" value={clients.length} icon={<Package size={20}/>} color="indigo" />
          <StatCard title="Revenue" value={formatCurrency(clients.reduce((s,c) => s + c.totalRevenue, 0))} icon={<DollarSign size={20}/>} color="emerald" />
          <StatCard title="Green" value={clients.filter(c => c.trust.score >= 75).length} icon={<UserCheck size={20}/>} color="blue" />
        </div>

        {/* Filters & Search */}
        <div className="bg-white dark:bg-slate-900 p-4 rounded-3xl border border-slate-100 dark:border-slate-800 shadow-sm space-y-4">
          <div className="relative">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-300 dark:text-slate-600" size={18} />
            <input
              type="text" placeholder="Rechercher..."
              className="w-full pl-12 pr-4 py-3 bg-slate-50 dark:bg-slate-800 dark:text-slate-100 border-none rounded-2xl focus:ring-2 focus:ring-indigo-500"
              value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="flex items-center gap-2 overflow-x-auto no-scrollbar">
            {['all', 'GREEN', 'BLUE', 'RED', 'BLACKLIST'].map(cat => (
              <button
                key={cat} onClick={() => setActiveFilter(cat)}
                className={`px-4 py-2 rounded-xl text-[10px] font-black tracking-widest uppercase transition-all whitespace-nowrap border ${activeFilter === cat ? 'bg-slate-900 text-white border-slate-900 dark:bg-slate-700 dark:border-slate-700' : 'bg-white dark:bg-slate-900 text-slate-400 dark:text-slate-500 border-slate-100 dark:border-slate-800'}`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        {/* Main Content (Table for Desktop, Cards for Mobile) */}
        <div className="hidden md:block bg-white dark:bg-slate-900 rounded-3xl border border-slate-100 dark:border-slate-800 shadow-xl overflow-hidden">
          <table className="w-full text-left">
            <thead className="bg-slate-50 dark:bg-slate-800/60 border-b border-slate-100 dark:border-slate-800">
              <tr>
                <th className="px-6 py-4 text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase">Client</th>
                <th className="px-6 py-4 text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase">Stats</th>
                <th className="px-6 py-4 text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase text-center">Trust</th>
                <th className="px-6 py-4 text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase text-right">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50 dark:divide-slate-800">
              {paginatedData.map(c => (
                <tr key={c.id} className="hover:bg-slate-50/50 dark:hover:bg-slate-800/50 transition-all">
                  <td className="px-6 py-4">
                    <div className="font-black text-slate-800 dark:text-slate-100 uppercase">{c.full_name}</div>
                    <div className="text-xs text-slate-400 dark:text-slate-500">{c.phone}</div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="text-xs font-bold text-slate-700 dark:text-slate-300">{c.totalOrders} CMD</div>
                    <div className="text-xs font-black text-emerald-500 dark:text-emerald-400">{formatCurrency(c.totalRevenue)}</div>
                  </td>
                  <td className="px-6 py-4 text-center">
                    <span className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-xl text-[10px] font-black border dark:border-transparent ${c.trust.styles.bg}`}>
                      <div className={`w-2 h-2 rounded-full ${c.trust.styles.dot}`} />
                      {c.trust.styles.label} {c.trust.score}%
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right">
                    <button onClick={() => setSelectedClient(c)} className="text-[10px] font-black bg-slate-100 dark:bg-slate-800 dark:text-slate-100 px-4 py-2 rounded-xl hover:bg-slate-900 hover:text-white dark:hover:bg-slate-700 transition-all">DÉTAILS</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile View (Cards) */}
        <div className="md:hidden space-y-4">
          {paginatedData.map(c => (
            <div key={c.id} className="bg-white dark:bg-slate-900 p-5 rounded-3xl border border-slate-100 dark:border-slate-800 shadow-sm space-y-4">
              <div className="flex justify-between items-start">
                <div>
                  <div className="font-black text-slate-800 dark:text-slate-100 uppercase">{c.full_name}</div>
                  <div className="text-xs text-slate-400 dark:text-slate-500">{c.phone}</div>
                </div>
                <span className={`px-3 py-1.5 rounded-xl text-[10px] font-black border dark:border-transparent ${c.trust.styles.bg}`}>
                   {c.trust.score}%
                </span>
              </div>
              <div className="flex justify-between items-center pt-2 border-t border-slate-50 dark:border-slate-800">
                <div className="text-xs font-black text-emerald-500 dark:text-emerald-400">{formatCurrency(c.totalRevenue)}</div>
                <button onClick={() => setSelectedClient(c)} className="text-[10px] font-black bg-indigo-50 dark:bg-indigo-500/10 text-indigo-600 dark:text-indigo-400 px-4 py-2 rounded-xl">DÉTAILS</button>
              </div>
            </div>
          ))}
        </div>

        {/* Professional Pagination Footer */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 bg-white dark:bg-slate-900 p-6 rounded-3xl border border-slate-100 dark:border-slate-800">
          <div className="flex items-center gap-3">
            <span className="text-xs font-bold text-slate-400 dark:text-slate-500 uppercase">Afficher</span>
            <select
              value={pageSize}
              onChange={(e) => setPageSize(Number(e.target.value))}
              className="bg-slate-50 dark:bg-slate-800 dark:text-slate-100 border-none rounded-xl text-xs font-black px-4 py-2 focus:ring-2 focus:ring-indigo-500"
            >
              {[10, 50, 100].map(v => <option key={v} value={v}>{v} LIGNES</option>)}
            </select>
          </div>

          <div className="flex items-center gap-2">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(prev => prev - 1)}
              className="p-2 rounded-xl border border-slate-100 dark:border-slate-800 disabled:opacity-30 hover:bg-slate-50 dark:hover:bg-slate-800 dark:text-slate-300"
            >
              <ChevronLeft size={20} />
            </button>
            <div className="text-xs font-black px-4 dark:text-slate-300">
              PAGE <span className="text-indigo-600 dark:text-indigo-400">{currentPage}</span> / {totalPages}
            </div>
            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(prev => prev + 1)}
              className="p-2 rounded-xl border border-slate-100 dark:border-slate-800 disabled:opacity-30 hover:bg-slate-50 dark:hover:bg-slate-800 dark:text-slate-300"
            >
              <ChevronRight size={20} />
            </button>
          </div>
        </div>

      </div>
      {selectedClient && <ClientDetailModal client={selectedClient} onClose={() => setSelectedClient(null)} />}
    </div>
  );
}

// StatCard & Modal components hna (nefs lli qbel m3a chwiya dyal responsive tweaks)...
function StatCard({ title, value, icon, color }) {
  const colors = {
    indigo: "bg-indigo-50 dark:bg-indigo-500/10 text-indigo-600 dark:text-indigo-400",
    emerald: "bg-emerald-50 dark:bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
    blue: "bg-blue-50 dark:bg-blue-500/10 text-blue-600 dark:text-blue-400"
  };
  return (
    <div className="bg-white dark:bg-slate-900 p-6 rounded-3xl border border-slate-50 dark:border-slate-800 shadow-sm flex items-center gap-4">
      <div className={`w-12 h-12 rounded-2xl ${colors[color]} flex items-center justify-center`}>{icon}</div>
      <div>
        <div className="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest">{title}</div>
        <div className="text-xl font-black text-slate-900 dark:text-slate-100">{value}</div>
      </div>
    </div>
  );
}

function ClientDetailModal({ client, onClose }) {
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4 bg-slate-900/60 dark:bg-black/70 backdrop-blur-md">
      <div className="bg-white dark:bg-slate-900 w-full max-w-xl rounded-[2.5rem] shadow-2xl overflow-y-auto max-h-[90vh]">
        <div className="p-8 space-y-6">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-black uppercase tracking-tighter dark:text-slate-100">{client.full_name}</h2>
            <button onClick={onClose} className="text-slate-400 dark:text-slate-500">✕</button>
          </div>
          <div className={`p-8 rounded-[2rem] text-center border-2 dark:border-transparent ${client.trust.styles.bg}`}>
            <div className="text-[10px] font-black uppercase mb-1">Score Actuel</div>
            <div className="text-5xl font-black">{client.trust.score}%</div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="p-4 bg-slate-50 dark:bg-slate-800/60 rounded-2xl">
              <div className="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase">Commandes</div>
              <div className="text-lg font-black dark:text-slate-100">{client.totalOrders}</div>
            </div>
            <div className="p-4 bg-slate-50 dark:bg-slate-800/60 rounded-2xl">
              <div className="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase">CA Total</div>
              <div className="text-lg font-black text-emerald-600 dark:text-emerald-400">{formatCurrency(client.totalRevenue)}</div>
            </div>
          </div>
          <div className="space-y-2">
            <div className="text-[10px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest">Analyse</div>
            <div className="flex flex-wrap gap-2">
              {client.trust.reasons.map((r, i) => (
                <span key={i} className="bg-slate-900 dark:bg-slate-700 text-white px-3 py-1.5 rounded-lg text-[9px] font-black uppercase tracking-widest">{r.replace(/_/g, ' ')}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
